import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Terms.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
const Terms = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    useEffect(() => {
        setInProp(true);
        document.title = "使用條款";
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Terms"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            <YStyled.Span size={17} color="#FF7700">隱私權與服務條款</YStyled.Span>

                            <YStyled.Span size={15} fontWeight={400}>歡迎使用OOSA！請花些時間閱讀以下條款，這些條款將規範您使用我們的服務以及我們如何處理您的個人資料。若您繼續使用本服務，即代表您同意以下條款內容。</YStyled.Span>

                            <YStyled.Span size={17} color="#FF7700">資料收集與使用</YStyled.Span>

                            <ul style={{ paddingLeft: "1.6rem" }}>
                                <li><YStyled.Span size={15} fontWeight={400}>我們可能會收集並使用您提供給我們的個人資料，包括但不限於姓名、電子郵件地址、聯絡資訊等，以便提供服務、聯絡您、處理付款等目的。</YStyled.Span></li>
                                <li><YStyled.Span size={15} fontWeight={400}>我們可能會使用GPS或類似技術來收集有關您位置的資訊，以提供相關的服務功能。您可以在設備上隨時選擇停用此功能。</YStyled.Span></li>
                                <li><YStyled.Span size={15} fontWeight={400}>我們可能會收集您提供的照片以及您的行程資料，以便為您提供相關服務，例如路線規劃、紀錄行程等。</YStyled.Span></li>
                                <li><YStyled.Span size={15} fontWeight={400}>我們可能會收集使用分析資料，包括但不限於您的設備資訊、應用程式使用情況、錯誤日誌等，以改善我們的服務品質。</YStyled.Span></li>
                            </ul>

                            <YStyled.Span size={17} color="#FF7700">資料共享</YStyled.Span>

                            <ul style={{ paddingLeft: "1.6rem" }}>
                                <li><YStyled.Span size={15} fontWeight={400}>我們不會向任何第三方出售、交換或租借您的個人資料，除非經您事先同意或符合法律規定。</YStyled.Span></li>
                                <li><YStyled.Span size={15} fontWeight={400}>我們可能會與合作夥伴共享某些資料，以便提供服務或改善用戶體驗，但我們將確保這些合作夥伴遵守適用的隱私權法規。</YStyled.Span></li>
                            </ul>

                            <YStyled.Span size={17} color="#FF7700">資料安全</YStyled.Span>

                            <ul style={{ paddingLeft: "1.6rem" }}>
                                <li><YStyled.Span size={15} fontWeight={400}>我們會採取適當的安全措施來保護您的個人資料免於遺失、滅失、竊取或未經授權的存取、揭露、修改或破壞。</YStyled.Span></li>
                                <li><YStyled.Span size={15} fontWeight={400}>您應該保護您的帳戶資訊，不應將帳戶密碼透露給任何第三方。</YStyled.Span></li>
                            </ul>

                            <YStyled.Span size={17} color="#FF7700">使用條款</YStyled.Span>

                            <ul style={{ paddingLeft: "1.6rem" }}>
                                <li><YStyled.Span size={15} fontWeight={400}>您同意遵守我們的使用條款，包括但不限於不得從事任何非法、侵權、煽動性或有害行為。</YStyled.Span></li>
                                <li><YStyled.Span size={15} fontWeight={400}>我們保留隨時修改或終止服務的權利，並將會提前通知您。</YStyled.Span></li>
                            </ul>

                            <YStyled.Span size={17} color="#FF7700">未成年人保護</YStyled.Span>

                            <ul style={{ paddingLeft: "1.6rem" }}>
                                <li><YStyled.Span size={15} fontWeight={400}>若您是未成年人，您應該在法定監護人的陪同下使用我們的服務。</YStyled.Span></li>
                            </ul>

                            <YStyled.Span size={17} color="#FF7700">隱私權政策的變更</YStyled.Span>


                            <ul style={{ paddingLeft: "1.6rem" }}>
                                <li><YStyled.Span size={15} fontWeight={400}>我們保留隨時修改本隱私權政策的權利，當我們進行重大修改時，我們將會在我們的網站上發布通知。</YStyled.Span></li>
                            </ul>
                            <YStyled.Span size={15} fontWeight={400}>如果您有任何疑問或關於本隱私權與服務條款的疑慮，請隨時與我們聯繫。</YStyled.Span>

                            <YStyled.Span size={15} fontWeight={400}>更新日期：[2024.05.10]</YStyled.Span>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Terms);